module.exports = __webpack_public_path__ + "img/7_no.ea3532b0.svg";